import { links } from '../../../hubble/src/constants/appRoutes';
import homeRoof from '../programs/HomeLight/assets/home-roof-2.png';
import homeLightLogo from '../programs/HomeLight/assets/the-card-logo.svg';
import homelightCardDesign from '../programs/HomeLight/assets/the-card.png';
import trovyLogo from '../programs/Trovy/assets/trovyLowResLogo.png';

import { createDefaultHelocFlow } from './createPartnerConfig';
import { Program } from './program';
import type { ProgramConfig } from './program.types';
import { programThemes } from './programTheme';

export const FlowType = {
  HELOC: 'heloc',
  CASH: 'cash',
  ITEM: 'item',
} as const;

export const programConfig: Partial<Record<Program, ProgramConfig>> = {
  [Program.HOMELIGHT]: createDefaultHelocFlow({
    logo: homeLightLogo,
    cardDesign: homelightCardDesign,
    favicon: '/homelight-favicon.svg',
    meta: {
      title: 'The Card Application',
      description: 'The Card Application',
    },
    theme: programThemes[Program.HOMELIGHT],
    images: {
      loginBg: homeRoof,
      homeRoof: homeRoof,
    },
    layout: {
      loginPage: {
        bgColor: '#07142F',
      },
    },
    texts: {
      cardName: 'The Card',
      programName: 'HomeLight',
      customerSupport: {
        phoneNumber: '(888) 221-9804',
        email: 'support@homelight.com',
      },
    },
    legalLinks: {
      privacyNotice: links.privacyNotice,
      privacyPolicy: links.privacyPolicy,
      rateDisclosure: links.rateDisclosureItem,
      termsOfService: links.termsOfService,
      rewardTerms: links.rewardsTerms,
      cardholderAgreement: links.cardholderAgreement,
      securityAgreement: links.securityAgreementItem,
      patriotAct: links.patriotAct,
      accountOpeningDisclosures: links.accountOpeningDisclosures,
      eSignDisclosure: links.eSignDisclosure,
      tcpa: links.tcpa,
    },
    links: {
      appStoreUrl: links.appStoreUrl,
      playStoreUrl: links.playStoreUrl,
    },
  }),
  [Program.TROVY]: createDefaultHelocFlow({
    logo: trovyLogo,
    favicon: '/trovy-favicon.svg',
    meta: {
      title: 'Trovy Mastercard',
      description: 'Trovy Mastercard',
    },
    theme: programThemes[Program.TROVY],
    images: {
      loginBg: homeRoof,
      homeRoof: homeRoof,
    },
    texts: {
      cardName: 'Trovy Mastercard®',
      programName: 'Trovy',
      customerSupport: {
        phoneNumber: '(888) 221-9804',
        email: 'support@trovy.com',
      },
    },
    legalLinks: {
      privacyNotice: links.privacyNotice,
      privacyPolicy: links.privacyPolicy,
      rateDisclosure: links.rateDisclosureItem,
      termsOfService: links.termsOfService,
      rewardTerms: links.rewardsTerms,
      cardholderAgreement: links.cardholderAgreement,
      securityAgreement: links.securityAgreementItem,
      patriotAct: links.patriotAct,
      accountOpeningDisclosures: links.accountOpeningDisclosures,
      eSignDisclosure: links.eSignDisclosure,
      tcpa: links.tcpa,
    },
    links: {
      appStoreUrl: links.appStoreUrl,
      playStoreUrl: links.playStoreUrl,
    },
  }),
};
